export default __webpack_public_path__ + "static/stena-bulk-horizontal-light-e5a0e2511f95728a9c516cda149d39e2.svg";